import * as i0 from "@angular/core";
export class LoadDrupalLangService {
    /**
     * Creates an instance of LoadDrupalLangService.
     * @memberof LoadDrupalLangService
     */
    constructor() {
        /**
         * The setted prefix for language.
         *
         * @memberof LoadDrupalLangService
         */
        this.langPrefix = '';
        this.langPrefix = this.getLang();
    }
    static getRawLang() {
        let lang = '';
        if (window && window['drupalSettings'] && window['drupalSettings']['path']) {
            const drupalSettings = window && window['drupalSettings'] ? window['drupalSettings'] : null;
            lang = drupalSettings['path']['currentLanguage'];
            lang = lang !== 'en' ? `${lang}` : `en`;
        }
        else {
            lang = 'en';
        }
        return lang;
    }
    /**
     * Method for get the lang prefix with slash.
     *
     * @returns the lang string with the properly prefix.
     * @memberof LoadDrupalLangService
     */
    getLang() {
        let lang = LoadDrupalLangService.getRawLang();
        lang = lang !== 'en' ? `/${lang}/` : `/`;
        return lang;
    }
}
LoadDrupalLangService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LoadDrupalLangService_Factory() { return new LoadDrupalLangService(); }, token: LoadDrupalLangService, providedIn: "root" });
